import React, { Fragment } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPreviousClick: () => void
  onNextClick: () => void
  onPageClick: (pageNumber: number) => void
}
const Pagination = ({
  currentPage,
  totalPages,
  onPreviousClick,
  onNextClick,
  onPageClick
}: PaginationProps) => {
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }


  const getPageNumberButtons = (): JSX.Element => {
    const maxNumberOfPageButtons = 6;
    const firstNPages = Math.floor(maxNumberOfPageButtons / 2);
    const lastNPages = Math.floor(maxNumberOfPageButtons / 2);
    return <>
      {pageNumbers.map(number => {
        const shouldAddElipsis = totalPages > maxNumberOfPageButtons && number === firstNPages + 1;
        const shouldAddPage = totalPages < maxNumberOfPageButtons || number <= firstNPages || number > (totalPages - lastNPages);
        if (shouldAddPage) {
          return (<button
            key={`page=${number}`}
            aria-current={(currentPage + 1) === number ? 'page' : undefined}
            className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold ${(currentPage + 1) === number ? 'bg-blue-600 text-white' : 'text-gray-900 hover:bg-gray-50'} ring-1 ring-inset ring-gray-300`}
            onClick={() => onPageClick(number - 1)}
          >
            {number}
          </button>);
        }
        if (shouldAddElipsis) {
          return (<button
            key={`page=elipsis`}
            className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50 ring-1 ring-inset ring-gray-300`}
          >
            ...
          </button>)
        }

        return <Fragment key={`page=${number}`}></Fragment>;
        })}
      </>
  };
  return (
    <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <div>
          <p className="text-sm text-gray-700">
            Page <span className="font-medium">{currentPage + 1}</span> of <span className="font-medium">{totalPages}</span>
          </p>
        </div>
        <div>
          <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
            <button
              onClick={onPreviousClick}
              disabled={currentPage === 0}
              className={`relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ${currentPage === 0 ? 'cursor-not-allowed' : 'hover:bg-gray-50'} ring-1 ring-inset ring-gray-300`}
            >
              <span className="sr-only">Previous</span>
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
            </button>
            {getPageNumberButtons()}
            <button
              onClick={onNextClick}
              disabled={(currentPage + 1) === totalPages}
              className={`relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ${(currentPage + 1) === totalPages ? 'cursor-not-allowed' : 'hover:bg-gray-50'} ring-1 ring-inset ring-gray-300`}
            >
              <span className="sr-only">Next</span>
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
